import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../../../programs.css";

const curriculumData = [
  {
    title: "IC Engine Foundations & Engine Classification",
    description:
      "Introduction to internal combustion engine & how it works, Types of engines: SI (Petrol) CI (Diesel) 2-stroke 4-stroke, Engine components & their functions, Engine cycles overview (Otto Diesel Dual), Applications in automobiles generators aviation & industry",
  },
  {
    title: "Thermodynamics of Engines & Combustion Science",
    description:
      "Thermodynamic principles applied in engines, PV diagrams heat transfer & efficiency calculation, Ignition flame propagation & combustion stages, Factors affecting combustion quality, Knock detonation & pre-ignition explained",
  },
  {
    title: "Fuel Systems, Fuel Injection & Air–Fuel Mixing",
    description:
      "Carburetors vs fuel injection systems, Port fuel injection common rail injection, Air–fuel ratios & stoichiometric combustion, Turbochargers & superchargers basics, Enhancing engine performance with fuel technology",
  },
  {
    title: "Engine Components, Materials & Mechanical Design",
    description:
      "Pistons crankshafts camshafts valves & connecting rods, Lubrication & cooling systems, Cylinder arrangement: inline V-engine boxer configuration, Material selection for durability, Understanding engine wear & maintenance",
  },
  {
    title: "Intake, Exhaust & Emission Control Systems",
    description:
      "Intake manifold design & airflow dynamics, Exhaust system components & catalytic converters, EGR (Exhaust Gas Recirculation) systems, Emission norms: BS6 Euro 6 EPA, Techniques to reduce pollution & improve efficiency",
  },
  {
    title: "Performance Parameters & Engine Tuning",
    description:
      "Power torque brake thermal efficiency, BSFC (Brake Specific Fuel Consumption), Engine maps & performance curves, ECU tuning & remapping basics, Methods to improve acceleration & fuel economy",
  },
  {
    title: "Starting Systems, Ignition Systems & Sensors",
    description:
      "Battery, starter motor & alternator workflow, Spark plug operation & ignition timing, Sensors: MAP MAF O2 TPS crank & cam sensors, ECU control of ignition & fuel supply, Diagnosing ignition system faults",
  },
  {
    title: "Engine Testing, Diagnostics & Fault Analysis",
    description:
      "Engine dynamometers & performance testing, Compression tests & leak-down tests, Vibration analysis & noise diagnostics, OBD-II scanning & error detection, Real-world troubleshooting of engine issues",
  },
  {
    title: "Modern Engine Technologies & Future Trends",
    description:
      "Variable valve timing (VVT VTEC), Direct injection & multi-stage turbocharging, Hybrid integration with ICE, Alternative fuels: CNG LPG biofuels hydrogen, The future of IC engines in the EV era",
  },
  {
    title: "Capstone IC Engine Project & Career Launchpad",
    description:
      "Design, analyze & simulate an IC engine model, Hands-on breakdown of engine components, Performance measurement report, Portfolio creation for automotive engineering roles, Interview prep for roles in engine design R&D service engineering",
  },
];

const ProgramCurriculum = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleSection = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="curriculum-container">
      <motion.h2
        className="curriculum-heading"
        initial={{ opacity: 0, y: -30 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
      >
        Program Curriculum
      </motion.h2>
      <motion.p
        className="curriculum-subtext"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 0.2, duration: 0.6 }}
      >
        This curriculum is structured in a practical and progressive format so
        you can learn step-by-step from zero to advanced level — and build
        real-world applications.
      </motion.p>
      <div className="curriculum-list">
        {curriculumData.map((item, index) => (
          <motion.div
            key={index}
            className="curriculum-item"
            onClick={() => toggleSection(index)}
            whileHover={{ x: 10 }}
            transition={{ duration: 0.3 }}
          >
            <div className="title-row">
              <span className="curriculum-title">{item.title}</span>
              <motion.span
                animate={{ rotate: activeIndex === index ? 90 : 0 }}
                transition={{ duration: 0.3 }}
                className="arrow"
              >
                ➤
              </motion.span>
            </div>
            <AnimatePresence>
              {activeIndex === index && (
                <motion.p
                  className="curriculum-description"
                  initial={{ opacity: 0, height: 0 }}
                  animate={{ opacity: 1, height: "auto" }}
                  exit={{ opacity: 0, height: 0 }}
                  transition={{ duration: 0.4 }}
                >
                  {item.description}
                </motion.p>
              )}
            </AnimatePresence>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default ProgramCurriculum;
